.row {
    display: flex;
    align-items: center;
}

/* Indentation levels with accordion toggle */
.inlineStylesLevel0 {
    margin: 0px;
}
.inlineStylesLevel1 {
    margin: 0px 0px 0px 25px;
}
.inlineStylesLevel2 {
    margin: 0px 0px 0px 50px;
}
.inlineStylesLevel3 {
    margin: 0px 0px 0px 75px;
}

/* Indentation levels without accordion toggle (leaf nodes) */
/* Arrow width is 34px, so add that to the base margin */
.inlineStylesNoArrowLevel0 {
    margin: 0px 0px 0px 34px;
}
.inlineStylesNoArrowLevel1 {
    margin: 0px 0px 0px 59px;
}
.inlineStylesNoArrowLevel2 {
    margin: 0px 0px 0px 84px;
}
.inlineStylesNoArrowLevel3 {
    margin: 0px 0px 0px 109px;
}

.hrModifier {
    margin: 0px;
    border: 1px solid var(--hps-blue);
    opacity: 0.06;
}
